<aside>
  <a class="company-logo" rel="noreferrer" routerLink="/" aria-label="Home">
    <img [height]="50" src="assets/svg/logoGoldRings.svg" alt="Anonymous Systems Logo" />
  </a>

  <nav>
    <ul>
      <li *ngFor="let menu_item of menuService.adminMenu" class="menu-item">
        <a [routerLink]="menu_item.routerLink"
           routerLinkActive="active-link"
           [routerLinkActiveOptions]="{exact:true}"
           matTooltipPosition="right"
           [matTooltip]="(isWebLandscape$ | async) ? '' : menu_item.name">
          <mat-icon>{{menu_item.icon}}</mat-icon>
          <span>{{menu_item.name}}</span>
        </a>
      </li>
    </ul>
  </nav>
</aside>

<header>
  <ng-container *ngIf="auth.user">
    <h2 class="greeting">Good {{time}}, {{auth.user.displayName}}</h2>

    <div class="user-container">
      <anon-user-header></anon-user-header>
    </div>
  </ng-container>
</header>

<main>
  <router-outlet></router-outlet>
</main>
